export const validateDiscount = value => {
  if (!value) {
    return 'Discount percentage is required.';
  }

  if (value % 1 !== 0) {
    return 'You can only enter numeric characters';
  }
};
export const handleChangeFlatDiscount = (flatDiscount, setFieldValue) => {
  setFieldValue('discountPercent', flatDiscount === 0 ? '' : flatDiscount.toString());
};